'use strict';

var isNode = typeof document === 'undefined';

var Classnames = require('classnames');
var React = require('react');
var ReactDOM = require('react-dom');
var LinkedStateMixin = require('react-addons-linked-state-mixin');

var Breadcrumbs = require('./breadcrumbs.jsx');
var Thumbs = require('./thumb-grids.jsx');

if (!isNode) {
    // co-topLevel namespace
    require('./collection-top-level.scss');
}

var Collections = React.createClass({
    mixins: [ LinkedStateMixin ],

    propTypes: {
        root: React.PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            root: true,
        };
    },
    getInitialState: function() {
        return {
            text: Payload.text,
            collections: Payload.Collections, // collections.php Collections::CollectionsAPI
        };
    },
    componentDidMount: function() {
        this.props.showFooter.requestChange(true);
    },
    render: function() {
        var type,
            breadcrumbs = [],
            category,
            categories,
            introTitle,
            introTagline,
            introBody,
            overrideIcon;

        if (this.props.root) {
            categories   = this.state.collections.filter((c) => {
                return c.seq != null;
            });
            type         = 'tiered';
            introTitle   = this.state.text['collections.title'];
            introTagline = null;
            introBody    = this.state.text['collections.body'];
        } else {
            category     = this.props.collectionMap[this.props.location.pathname];
            categories   = category.subcats;
            type         = 'grid';
            breadcrumbs.push({
                name: category.name,
                url: category.url
            });
            introTitle   = category.title.toUpperCase();
            introTagline = category.tagline.toUpperCase();
            introBody    = category.body;
            overrideIcon = 'office-chair';
        }
        return (
            <div className='co-topLevel'>
                <TopLevelHeader introTitle   = {introTitle}
                                introTagline = {introTagline}
                                introBody    = {introBody}
                                breadcrumbs  = {breadcrumbs}
                                categories   = {Payload.Collections}
                                type         = {this.props.root}
                                category     = {category}
                                route        = {this.props.route} />

                <Thumbs thumbs       = {categories}
                        type         = {type}
                        overrideIcon = {overrideIcon} />
            </div>
        );
    }
});

var SubCollections = React.createClass({
    render: function() {
        return (
            <Collections root          = {false}
                         location      = {{ pathname: this.props.location.pathname }}
                         showFooter    = {this.props.showFooter}
                         collectionMap = {this.props.route.collectionMap} />
        );
    },
});

var TopLevelHeader = React.createClass({
    render: function() {
        return (
            <div className='co-header co-blockheader'>
                <Breadcrumbs trail      = {this.props.breadcrumbs}
                             categories = {this.props.categories}
                             route      = {this.props.route} />
                <div className='co-topLevel-intro' dangerouslySetInnerHTML={{ __html: this.props.introBody }} />
            </div>
        );
    }
});

module.exports = {
    Collections: Collections,
    SubCollections: SubCollections,
};



// WEBPACK FOOTER //
// ./src/collections/collection-top-level.jsx